import { render, staticRenderFns } from "./cambio-direccion.vue?vue&type=template&id=379e1e97&"
import script from "./cambio-direccion.vue?vue&type=script&lang=ts&"
export * from "./cambio-direccion.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports